'use client';

import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import classNames from 'classnames';

import { Icon } from '../../atoms/Icon';
import { Button, DesignType } from '../../atoms/Button';
import styles from './index.module.scss';

export interface CallUsNavButtonProps extends ComponentPropsWithoutRef<'div'> {
  readonly phoneNumber: string;
  readonly buttonText: string;
  readonly desktopStyle?: 'white' | 'purple';
}

export function CallUsNavButton({
  phoneNumber,
  buttonText,
  desktopStyle = 'white',
  className,
  ...props
}: CallUsNavButtonProps): JSX.Element {
  return (
    <div className={classNames(CallUsNavButton.displayName, styles.component, className)} {...props}>
      <a
        className={classNames(styles['call-us-cta-desktop'], styles[desktopStyle])}
        href={`tel:${phoneNumber.replaceAll(' ', '')}`}
      >
        <Icon
          id="communication/phone"
          className={classNames(styles.desktopIcon)}
          width={20}
          height={20}
          legacy={false}
        />
        {phoneNumber}
      </a>
      <Button
        className={classNames(styles['call-us-cta-mobile'])}
        iconId="communication/phone"
        designType={DesignType.SECONDARY_DARK}
        href={`tel:${phoneNumber}`}
        size="S"
      >
        {buttonText}
      </Button>
    </div>
  );
}

CallUsNavButton.displayName = 'CallUsNavButton';
